"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenChatsProvider = void 0;
const ChatsProvider_1 = require("./ChatsProvider");
const HiddenChatsContext_1 = require("./HiddenChatsContext");
exports.HiddenChatsProvider = (0, ChatsProvider_1.createChatProvider)(HiddenChatsContext_1.HiddenChatsContext, {
    getChatManager: selectedOrgUser => selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getHiddenGroupChatManager(),
});
